const SaveUserTemplateIcon = ({  }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
           `${basePath}/save-template-enable.png`
      }
      alt="Save User Template"
      style={{ width: 18, height: 16 , border : '2px solid white', marginBottom: 1.3}}
    />
  );
};

export default SaveUserTemplateIcon;
